import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    login: '',
    name: '',
    permissions: []
}

export const UserSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        SetLogin: (state, action) => {
        // Redux Toolkit allows us to write "mutating" logic in reducers. It
        // doesn't actually mutate the state because it uses the Immer library,
        // which detects changes to a "draft state" and produces a brand new
        // immutable state based off those changes
        state.login = action.payload
        },
        delLogin: (state) => {
        state.login = null
        },
        setName: (state, action) => {
          state.name = action.payload
        },
        delName: (state) => {
            state.name = null
        },
        setPermissions: (state, action) => {
            state.permissions = action.payload
        },
        delPermissions: (state) => {
            state.permissions = [];
        }
    }
  })
  
  // Action creators are generated for each case reducer function
  export const { SetLogin, delLogin, setName, delName, setPermissions, delPermissions } = UserSlice.actions
  
  export default UserSlice.reducer